import { useMutation } from '@tanstack/react-query'
import { UseBaseMutationOptions } from '@/core/api/type'

import { settingsService } from '../services'

import type { CreateHotGameFlexMessageDto } from '../../types'

const useMutationCreateFlexHotGame = (
	baseQueryOptions?: UseBaseMutationOptions<
		unknown,
		CreateHotGameFlexMessageDto
	>,
) => {
	return useMutation({
		mutationFn: (data: CreateHotGameFlexMessageDto) =>
			settingsService.createFlexHotGame(data),
		...baseQueryOptions,
	})
}

export default useMutationCreateFlexHotGame
